import React from 'react';
import { cn } from '../utils';

export interface TooltipProps {
  content: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  variant?: 'primary' | 'secondary' | 'accent' | 'info' | 'success' | 'warning' | 'error';
  children: React.ReactNode;
  className?: string;
}

export const Tooltip: React.FC<TooltipProps> = ({
  content,
  position = 'top',
  variant,
  children,
  className,
}) => {
  const tooltipClasses = cn(
    'tooltip',
    position === 'top' && 'tooltip-top',
    position === 'bottom' && 'tooltip-bottom',
    position === 'left' && 'tooltip-left',
    position === 'right' && 'tooltip-right',
    variant === 'primary' && 'tooltip-primary',
    variant === 'secondary' && 'tooltip-secondary',
    variant === 'accent' && 'tooltip-accent',
    variant === 'info' && 'tooltip-info',
    variant === 'success' && 'tooltip-success',
    variant === 'warning' && 'tooltip-warning',
    variant === 'error' && 'tooltip-error',
    className
  );

  return (
    <div className={tooltipClasses} data-tip={content}>
      {children}
    </div>
  );
};
